import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_gosto-marseille-1/artifacts/5h91p5vw_ChatGPT%20Image%2013%20f%C3%A9vr.%202026%2C%2021_11_06%20-%20Copie.png";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex-shrink-0">
              <img src={LOGO_WHITE} alt="GOSTO TAXI Marseille" className="h-14 w-auto" />
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#1a365d] text-[#1a365d]">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="py-16 md:py-24" data-testid="mentions-legales-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1a365d] mb-8">Mentions Légales</h1>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Éditeur du site</h2>
              <p className="text-slate-600 mt-4">
                <strong>Raison sociale :</strong> GOSTO TAXI<br />
                <strong>SIRET :</strong> 993 322 619<br />
                <strong>Responsable de publication :</strong> Oualid AHAMRI<br />
                <strong>Adresse :</strong> 4 Traverse Aubanel, 13140 Miramas<br />
                <strong>Téléphone :</strong> 07 72 06 72 23<br />
                <strong>Email :</strong> contact@gostotaxi.com
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Activité</h2>
              <p className="text-slate-600 mt-4">
                GOSTO TAXI est un service de taxi rattaché à la ville de Marseille, conventionné par la CPAM pour le transport assis professionnalisé (TAP).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Hébergement</h2>
              <p className="text-slate-600 mt-4">
                <strong>Hébergeur :</strong> Emergent.sh<br />
                <strong>Site web :</strong> www.gostotaxi.com
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Propriété intellectuelle</h2>
              <p className="text-slate-600 mt-4">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p className="text-slate-600 mt-2">
                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Limitation de responsabilité</h2>
              <p className="text-slate-600 mt-4">
                Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.
              </p>
              <p className="text-slate-600 mt-2">
                Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, merci de bien vouloir le signaler par email à ahamri.oualid@gmail.com.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1a365d] border-b-2 border-[#f7c52d] pb-2">Crédits</h2>
              <p className="text-slate-600 mt-4">
                <strong>Conception et réalisation :</strong> Emergent.sh<br />
                <strong>Photographies :</strong> Unsplash.com
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0f172a] py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-400 text-sm">
          © 2025 GOSTO TAXI. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
}
